import { createStore } from 'vuex'
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";

import { getStore } from "@/utils/storage";

const state = {
  token: getStore('token') || '',
  //存储每一级路由(之前一次路由)
  routerEveryLevel: [],
  //用户登录信息
  userInfo: getStore('userInfo') || {},
  // 登录状态
  isLogin: getStore('isLogin') || false,
  // 角色Id
  roleId: getStore('roleId') || ''
};

export default createStore({
  state,
  getters,
  mutations,
  actions,
});
